// extracted by mini-css-extract-plugin
module.exports = {"viewport":"jpG0SUH8hGTMZEn9dBln9g=="};